export const dermatovenerologyConst = {
  path: "/single-programs/dermatovenerology",
  title: "ФАКУЛЬТЕТ МЕДИЦИНЫ — ДЕРМАТОВЕНЕРОЛОГИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> магистра
      </p>
      <p>
        <strong>Форма обучения:</strong> очная или дистанционная
      </p>
      <p>
        <strong>Форма связи:</strong> получить консультацию приемной комиссии
      </p>
      <h2>Дерматовенерология — наука о коже, здоровье и уверенности</h2>
      <p>
        Дерматовенерология — это медицинская специальность, объединяющая диагностику и лечение заболеваний кожи, слизистых оболочек, волос,
        ногтей, а также инфекций, передающихся половым путём. Особое внимание уделяется эстетическим аспектам и профилактике.
      </p>
      <p>Программа сочетает в себе классическую медицину и современные методы дерматологической и косметологической помощи.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Кожные заболевания: экзема, псориаз, акне</li>
        <li>Венерология: ИППП, профилактика и лечение</li>
        <li>Дерматопатология и микология</li>
        <li>Диагностика и дерматоскопия</li>
        <li>Лазерная и аппаратная терапия</li>
        <li>Эстетическая дерматология и уход за кожей</li>
        <li>Аллергические реакции и аутоиммунные процессы</li>
        <li>Медицинская этика, коммуникация с пациентами</li>
      </ul>
      <p>Практика проходит в дерматологических клиниках, косметологических центрах, кожно-венерологических диспансерах и лабораториях.</p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Дерматолог в клиниках и медцентрах</li>
        <li>Венеролог в КВД и частной практике</li>
        <li>Дерматокосметолог — работа в бьюти- и wellness-индустрии</li>
        <li>Специалист по диагностике кожных заболеваний</li>
        <li>Консультант в фармкомпаниях и индустрии ухода за кожей</li>
        <li>Преподаватель или научный сотрудник</li>
      </ul>
      <h2>Востребованность и доход</h2>
      <p>Спрос на специалистов по дерматовенерологии стабильно высок в Европе и мире.</p>
      <p>
        <strong>Средний доход — от €60,000 до €110,000 в год,</strong> в зависимости от специализации, региона и опыта.
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом магистра</li>
        <li>Возможность обучения на русском и английском языках</li>
        <li>Доступ как к очному, так и к дистанционному формату</li>
        <li>Оснащенные лаборатории и симуляционные центры</li>
        <li>Стажировки в клиниках ЕС и косметологических институтах</li>
        <li>Поддержка в трудоустройстве и карьерном развитии</li>
      </ul>
      <h2>Учёба, которая делает жизнь людей качественнее</h2>
      <p>
        Наши выпускники становятся ведущими специалистами в дерматологии и косметологии, возвращая людям здоровье, уверенность и комфорт.
      </p>
      <br />
      <p className="padding-left">«Кожа — зеркало здоровья. Мы учим читать это зеркало и помогать каждому пациенту.»</p>
      <h2>Как поступить?</h2>
      <p>Оставьте заявку, пройдите консультацию и получите подробную информацию о стоимости, сроках и документах.</p>
    </>
  ),
  contentSearch: `
    Диплом: магистра
    Форма обучения: очная или дистанционная
    Форма связи: Получить консультацию приемной комиссии

    Дерматовенерология — наука о коже, здоровье и уверенности
    Дерматовенерология — это медицинская специальность, объединяющая диагностику и лечение заболеваний кожи, слизистых оболочек, волос, ногтей, а также инфекций, передающихся половым путём. Особое внимание уделяется эстетическим аспектам и профилактике.
    Программа сочетает в себе классическую медицину и современные методы дерматологической и косметологической помощи.

    Что вы будете изучать?
    • Кожные заболевания: экзема, псориаз, акне
    • Венерология: ИППП, профилактика и лечение
    • Дерматопатология и микология
    • Диагностика и дерматоскопия
    • Лазерная и аппаратная терапия
    • Эстетическая дерматология и уход за кожей
    • Аллергические реакции и аутоиммунные процессы
    • Медицинская этика, коммуникация с пациентами
    Практика проходит в дерматологических клиниках, косметологических центрах, кожно-венерологических диспансерах и лабораториях.

    Кем можно работать после окончания?
    • Дерматолог в клиниках и медцентрах
    • Венеролог в КВД и частной практике
    • Дерматокосметолог — работа в бьюти- и wellness-индустрии
    • Специалист по диагностике кожных заболеваний
    • Консультант в фармкомпаниях и индустрии ухода за кожей
    • Преподаватель или научный сотрудник

    Востребованность и доход
    Спрос на специалистов по дерматовенерологии стабильно высок в Европе и мире.
    Средний доход — от €60,000 до €110,000 в год, в зависимости от специализации, региона и опыта.

    Почему выбирают нас?
    • Европейский диплом магистра
    • Возможность обучения на русском и английском языках
    • Доступ как к очному, так и к дистанционному формату
    • Оснащенные лаборатории и симуляционные центры
    • Стажировки в клиниках ЕС и косметологических институтах
    • Поддержка в трудоустройстве и карьерном развитии

    Учёба, которая делает жизнь людей качественнее
    Наши выпускники становятся ведущими специалистами в дерматологии и косметологии, возвращая людям здоровье, уверенность и комфорт.
    «Кожа — зеркало здоровья. Мы учим читать это зеркало и помогать каждому пациенту.»

    Как поступить?
    Оставьте заявку, пройдите консультацию и получите подробную информацию о стоимости, сроках и документах.
  `,
};
